import { render, staticRenderFns } from "./Aboutr.vue?vue&type=template&id=776f06be&"
import script from "./Aboutr.vue?vue&type=script&lang=js&"
export * from "./Aboutr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports